<template>
   <div>
      <!-- ── DETALLE DE UNA NOTIFICACIÓN ──────────────────────────────────── -->
      <v-dialog v-model="dialogEnvio" max-width="620px">
         <v-card v-if="envioSel">
            <v-card-title class="text-h6">
               {{ envioSel.mesNombre }} {{ envioSel.anio }}
               <v-chip
                  small
                  label
                  class="ml-2"
                  :color="colorEstado(envioSel.estado)"
                  text-color="white"
               >
                  {{ etiquetaEstado(envioSel.estado) }}
               </v-chip>
            </v-card-title>
            <v-card-text class="text--primary">
               <v-simple-table dense>
                  <template #default>
                     <tbody>
                        <tr>
                           <td class="grey--text">
                              Habilitado por Registro Académico
                           </td>
                           <td>{{ envioSel.fechaEnvio || '—' }}</td>
                        </tr>
                        <tr>
                           <td class="grey--text">Alumnos</td>
                           <td>{{ envioSel.filas }}</td>
                        </tr>
                        <tr>
                           <td class="grey--text">Detectado por el sistema</td>
                           <td>{{ envioSel.detectadoEl || '—' }}</td>
                        </tr>
                        <tr v-if="envioSel.importado">
                           <td class="grey--text">Procesado</td>
                           <td>
                              {{ envioSel.importadoEl }}
                              <span v-if="envioSel.importadoPor">
                                 por {{ envioSel.importadoPor }}
                              </span>
                              · {{ envioSel.filasImportadas }} alumno(s)
                           </td>
                        </tr>
                        <tr v-if="envioSel.descartado">
                           <td class="grey--text">Descartado</td>
                           <td>
                              {{ envioSel.descartadoEl }} — se conservó lo que
                              ya estaba cargado
                           </td>
                        </tr>
                        <tr v-if="envioSel.hayCambios">
                           <td class="grey--text">Modificado después</td>
                           <td class="orange--text text--darken-3">
                              {{ envioSel.fechaCambio }}
                           </td>
                        </tr>
                     </tbody>
                  </template>
               </v-simple-table>

               <v-alert
                  v-if="envioSel.estado === 'PENDIENTE'"
                  dense
                  dark
                  color="#6C1C19"
                  icon="fas fa-info-circle"
                  class="mt-3 mb-0 text-body-2"
               >
                  Este listado todavía no se ha procesado. Puede hacerlo desde
                  aquí.
               </v-alert>

               <v-alert
                  v-else-if="envioSel.estado === 'MODIFICADO'"
                  dense
                  text
                  type="warning"
                  class="mt-3 mb-0 text-body-2"
               >
                  Registro Académico cambió este listado después de que se
                  procesara. Revise qué cambió y, si corresponde, vuelva a
                  procesarlo.
               </v-alert>

               <v-alert
                  v-else-if="envioSel.estado === 'DESCARTADO'"
                  dense
                  dark
                  color="#6C1C19"
                  icon="fas fa-info-circle"
                  class="mt-3 mb-0 text-body-2"
               >
                  En su momento se prefirió conservar el listado que ya estaba
                  cargado. Si cambió de parecer, puede procesarlo ahora.
               </v-alert>
            </v-card-text>
            <v-card-actions>
               <v-btn
                  v-if="envioSel.importado"
                  text
                  small
                  @click="verCambios(envioSel.anio, envioSel.mes)"
               >
                  Ver qué cambió
               </v-btn>

               <v-spacer />
               <v-btn text @click="dialogEnvio = false">Cerrar</v-btn>
               <v-btn
                  v-if="permController(34, 'crear')"
                  color="primary"
                  :loading="importando"
                  @click="procesarEnvio"
               >
                  <v-icon left x-small>fas fa-download</v-icon>
                  {{
                     envioSel.importado
                        ? 'Volver a procesar'
                        : 'Procesar este listado'
                  }}
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <!-- ── CICLO DEL listadoo de alumnos ─────────────────────────────────────────────── -->
      <v-dialog v-model="dialogCiclo" max-width="680px" persistent>
         <v-card>
            <v-card-title class="text-h6">
               ¿A qué ciclo pertenece este listado de alumnos?
            </v-card-title>
            <v-card-text class="text--primary">
               <p class="text-caption grey--text mb-2">
                  Registro Académico no envía el ciclo con el formato del
                  módulo, así que hay que indicarlo. El sistema puede deducirlo
                  de las cuotas que vencen en {{ objetivo.mesNombre }}
                  {{ objetivo.anio }}.
               </p>

               <v-radio-group v-model="modoCiclo" class="mt-0" hide-details>
                  <v-radio value="automatico">
                     <template #label>
                        <span>
                           <strong>Tomar el ciclo automáticamente</strong>
                           <span class="text-caption grey--text d-block">
                              Se deduce mirando qué cuotas vencen ese mes
                           </span>
                        </span>
                     </template>
                  </v-radio>
                  <v-radio value="manual">
                     <template #label>
                        <span>
                           <strong>Indicar los ciclos a mano</strong>
                           <span class="text-caption grey--text d-block">
                              Igual que al cargar el archivo de Registro
                              Académico.
                           </span>
                        </span>
                     </template>
                  </v-radio>
               </v-radio-group>

               <!-- ── Lo que se dedujo ─────────────────────────────────── -->
               <template v-if="modoCiclo === 'automatico'">
                  <v-alert
                     v-if="ciclosDetectados.ciclo"
                     dense
                     text
                     type="success"
                     class="mt-3 mb-2 text-body-2"
                  >
                     <strong>{{ ciclosDetectados.ciclo }}</strong>
                     <span v-if="ciclosDetectados.cicloAlterno">
                        y <strong>{{ ciclosDetectados.cicloAlterno }}</strong>
                     </span>
                  </v-alert>

                  <v-alert
                     v-else
                     dense
                     text
                     type="warning"
                     class="mt-3 mb-2 text-body-2"
                  >
                     {{
                        ciclosDetectados.explicacion ||
                        'No se pudo deducir el ciclo de ese mes. Indíquelo a mano.'
                     }}
                  </v-alert>
               </template>

               <!-- ── A mano ───────────────────────────────────────────── -->
               <v-row v-else dense class="mt-3">
                  <v-col cols="12" sm="6">
                     <v-select
                        v-model="cicloManual"
                        :items="ciclos"
                        label="Ciclo al que pertenece estos alumnos"
                        outlined
                        dense
                        hide-details
                     />
                  </v-col>
                  <v-col cols="12" sm="6">
                     <v-select
                        v-model="cicloAlternoManual"
                        :items="ciclos"
                        label="Ciclo adicional (opcional)"
                        outlined
                        dense
                        hide-details
                        clearable
                     />
                  </v-col>
                  <v-col cols="12">
                     <p class="text-caption grey--text mb-0 mt-2">
                        Usar el ciclo adicional cuando el mes pertenezca a dos
                        ciclos a la vez: en junio, Enfermería ya paga la cuota 1
                        del ciclo que comienza mientras el resto sigue en el
                        anterior.
                     </p>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer />
               <v-btn text @click="dialogCiclo = false">Cancelar</v-btn>
               <v-btn
                  color="primary"
                  :loading="importando"
                  :disabled="!cicloElegido"
                  @click="continuarDesdeCiclo"
               >
                  Continuar
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <!-- ── CONFLICTO: EXCEL O REGISTRO ACADÉMICO ────────────────────────── -->
      <v-dialog v-model="dialogConflicto" max-width="680px" persistent>
         <v-card>
            <v-card-title class="text-h6">
               ¿Con cuál de los dos listados se queda?
            </v-card-title>
            <v-card-text class="text--primary">
               <!-- El texto lo arma el backend, que es quien sabe cuántos
                    alumnos hay de cada lado. Así sirve igual venga el conflicto
                    del aviso o de la campana. -->
               <v-alert dense text type="warning" class="mb-3">
                  {{ mensajeConflicto }}
               </v-alert>

               <v-radio-group v-model="decision" class="mt-0" hide-details>
                  <v-radio :value="RA">
                     <template #label>
                        <span>
                           <strong>Usar el de Registro Académico</strong>
                           <span class="text-caption grey--text d-block">
                              El listado del mes pasa a ser el de Registro
                              Académico. Quien no venga en él se da de baja,
                              igual que al subir un archivo completo. El
                              teléfono que ya tengamos se conserva, porque ellos
                              no lo envían.
                           </span>
                        </span>
                     </template>
                  </v-radio>
                  <v-radio :value="EXCEL">
                     <template #label>
                        <span>
                           <strong>Conservar lo que ya está cargado</strong>
                           <span class="text-caption grey--text d-block">
                              No se toca nada. El envío queda registrado como
                              descartado y se puede volver a importar después
                              desde la campana.
                           </span>
                        </span>
                     </template>
                  </v-radio>
               </v-radio-group>
            </v-card-text>
            <v-card-actions>
               <v-spacer />
               <v-btn text @click="dialogConflicto = false">Cancelar</v-btn>
               <v-btn
                  color="primary"
                  :loading="importando"
                  :disabled="!decision"
                  @click="importar(decision)"
               >
                  Continuar
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <!-- ── QUÉ CAMBIÓ ───────────────────────────────────────────────────── -->
      <v-dialog v-model="dialogCambios" max-width="1100px" scrollable>
         <v-card>
            <v-card-title class="text-h6">
               Cambios de Registro Académico
            </v-card-title>
            <v-card-text class="text--primary" style="max-height: 480px">
               <p class="mb-3">{{ cambios.mensaje }}</p>

               <v-data-table
                  :headers="headersCambios"
                  :items="cambios.detalle || []"
                  :items-per-page="10"
                  :footer-props="pieTabla"
                  dense
                  class="elevation-1"
                  no-data-text="No se ha registrado ningún cambio de este mes."
               >
                  <template #[`item.etiquetaTipo`]="{ item }">
                     <v-chip
                        x-small
                        label
                        :color="colorCambio(item.tipo)"
                        text-color="white"
                     >
                        {{ item.etiquetaTipo }}
                     </v-chip>
                  </template>
                  <template #[`item.usInforme`]="{ item }">
                     <span v-if="item.usInforme">{{ item.usInforme }}</span>
                     <span v-else class="grey--text">—</span>
                  </template>
                  <template #[`item.fechaEnvioRa`]="{ item }">
                     <span v-if="item.fechaEnvioRa">{{
                        item.fechaEnvioRa
                     }}</span>
                     <span v-else class="grey--text">—</span>
                  </template>
               </v-data-table>
            </v-card-text>
            <v-card-actions>
               <v-spacer />
               <v-btn text @click="dialogCambios = false">Cerrar</v-btn>
               <v-btn
                  v-if="cambios.hay && permController(34, 'crear')"
                  color="primary"
                  :loading="importando"
                  @click="importar(RA)"
               >
                  Volver a importar
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <!-- ── AVISO ────────────────────────────────────────────────────────── -->
      <!-- La campana con el historial vive en la barra superior
           (CampanaIntegracion.vue); acá quedan solo los avisos. Un cambio
           posterior sigue en naranja: es una advertencia y tiene que
           distinguirse del aviso corriente. -->
      <v-alert
         v-if="mostrarAviso"
         :type="aviso.hayCambios ? 'warning' : null"
         :color="aviso.hayCambios ? null : '#6C1C19'"
         :icon="aviso.hayCambios ? undefined : 'fas fa-bullhorn'"
         dark
         prominent
         border="left"
         class="mb-2"
      >
         <div class="text-subtitle-1 font-weight-medium">
            {{
               aviso.hayCambios
                  ? 'Registro Académico modificó información ya procesada'
                  : 'Registro Académico habilitó información para su procesamiento'
            }}
         </div>
         <div class="text-body-2 mt-1">{{ aviso.mensaje }}</div>

         <div class="d-flex align-center flex-wrap mt-3">
            <v-btn
               v-if="permController(34, 'crear')"
               color="white"
               light
               small
               class="mr-2 mb-1"
               :loading="importando"
               @click="comenzarImportacion()"
            >
               <v-icon left x-small>fas fa-download</v-icon>
               {{
                  aviso.hayCambios ? 'Revisar y actualizar' : 'Procesar ahora'
               }}
            </v-btn>

            <v-btn
               v-if="aviso.hayCambios"
               text
               small
               class="mr-2 mb-1"
               @click="verCambios(aviso.anio, aviso.mes)"
            >
               Ver qué cambió
            </v-btn>

            <v-spacer />

            <v-checkbox
               v-model="noMostrar"
               dense
               hide-details
               class="mt-0 mb-1"
               label="No volver a mostrar este mensaje"
               @change="omitir"
            />
         </div>

         <div class="text-caption mt-1">
            Se oculta solo el aviso de {{ aviso.mesNombre }} {{ aviso.anio }}.
            Cuando Registro Académico habilite el mes siguiente, el aviso
            volverá a aparecer.
         </div>
      </v-alert>
   </div>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../../helpers'
import {
   colorEstado,
   etiquetaEstado,
   EVENTO_ENVIOS_ACTUALIZADOS
} from './estadoEnvio'

/**
 * Segunda vía de carga del listado: la que trae Registro Académico.
 *
 * Registro Académico habilita el listado de cada mes en su propio sistema. Este
 * componente lo detecta al abrirse la pantalla, lo avisa, y deja importarlo.
 * La importación no tiene lógica propia: el backend arma las mismas filas que
 * armaría el Excel y las pasa por la misma carga, así que el resultado es el
 * mismo venga de donde venga.
 *
 * La campana con el historial de envíos está en la barra superior
 * (CampanaIntegracion.vue). Al elegir un mes allí se llega a esta pantalla con
 * ?envioAnio=&envioMes= y desde acá se abre el detalle y se procesa.
 */
export default {
   name: 'PadronRegistroAcademico',
   props: {
      ciclo: {
         type: String,
         default: null
      },
      /** Segundo ciclo del mes, el mismo que se usa al subir el archivo. */
      cicloAlterno: {
         type: String,
         default: null
      },
      /** Catálogo de ciclos, para cuando se indiquen a mano. */
      ciclos: {
         type: Array,
         default: () => []
      }
   },
   data() {
      return {
         EXCEL: 'EXCEL',
         RA: 'REGISTRO_ACADEMICO',

         aviso: {},
         envios: [],
         cambios: {},

         noMostrar: false,
         importando: false,

         dialogEnvio: false,
         envioSel: null,

         // Qué listado se está procesando: el del aviso o el que se eligió en la
         // campana. Todo el flujo trabaja sobre esto y no sobre el aviso, que
         // es solo una de las dos puertas de entrada.
         objetivo: {},
         mensajeConflicto: '',

         dialogCiclo: false,
         modoCiclo: 'automatico',
         ciclosDetectados: {},
         cicloManual: null,
         cicloAlternoManual: null,

         dialogConflicto: false,
         decision: null,

         dialogCambios: false,

         headersCambios: [
            { text: 'Alumno', value: 'nombreCompleto' },
            { text: 'Carnet', value: 'carnet' },
            { text: 'Qué pasó', value: 'etiquetaTipo' },
            { text: 'Detalle', value: 'detalle' },
            { text: 'Informado por', value: 'usInforme' },
            { text: 'Fecha de envío', value: 'fechaEnvioRa' },
            { text: 'Detectado', value: 'detectadoEl' }
         ],

         // Vuetify viene en inglés y el proyecto no configura idioma global.
         pieTabla: {
            'items-per-page-text': 'Filas por página',
            'items-per-page-options': [10, 25, 50, -1],
            'items-per-page-all-text': 'Todas',
            'page-text': '{0}-{1} de {2}'
         }
      }
   },
   computed: {
      ...authComputed,
      /**
       * El aviso se muestra cuando hay algo pendiente y el usuario no lo ha
       * silenciado para ese mes.
       */
      mostrarAviso() {
         return !!this.aviso.hay && !this.aviso.omitido
      },
      /** El ciclo con el que se va a procesar, según el modo elegido. */
      cicloElegido() {
         return this.modoCiclo === 'manual'
            ? this.cicloManual
            : this.ciclosDetectados.ciclo
      },
      cicloAlternoElegido() {
         return this.modoCiclo === 'manual'
            ? this.cicloAlternoManual
            : this.ciclosDetectados.cicloAlterno
      },
      usuario() {
         return this.oidcUser ? this.oidcUser.name : 'Desconocido'
      }
   },
   watch: {
      // Elegir otro mes en la campana estando ya en la pantalla solo cambia la
      // dirección: el componente no se vuelve a crear.
      '$route.query'() {
         this.abrirEnvioDeLaRuta()
      }
   },
   created() {
      this.cargarAviso()
      this.abrirEnvioDeLaRuta()
   },
   methods: {
      avisar(texto, color = 'success') {
         this.$emit('mensaje', texto, color)
      },
      mensajeError(error, respaldo) {
         return error.response && error.response.data
            ? error.response.data
            : respaldo
      },

      cargarAviso() {
         axios
            .get('api/Integracion/padron-ra/aviso', {
               params: { usuario: this.usuario }
            })
            .then(({ data }) => {
               this.aviso = data || {}
               this.noMostrar = !!this.aviso.omitido
            })
            .catch((error) => console.log(error))
      },
      cargarEnvios() {
         return axios
            .get('api/Integracion/padron-ra/envios')
            .then(({ data }) => {
               this.envios = data || []
            })
            .catch((error) => console.log(error))
      },

      /**
       * Silencia el aviso del mes. No se puede deshacer desde acá a propósito:
       * es una preferencia menor, y el mes siguiente vuelve a avisar solo.
       */
      omitir(marcado) {
         if (!marcado) return

         axios
            .post('api/Integracion/padron-ra/omitir-aviso', {
               anio: this.aviso.anio,
               mes: this.aviso.mes,
               usuario: this.usuario
            })
            .then(() => {
               this.aviso = { ...this.aviso, omitido: true }
               this.avisar(
                  `No se volverá a mostrar el aviso de ${this.aviso.mesNombre} ${this.aviso.anio}.`
               )
            })
            .catch((error) => {
               this.noMostrar = false
               this.avisar(
                  this.mensajeError(
                     error,
                     'No se pudo guardar la preferencia.'
                  ),
                  'error'
               )
            })
      },

      /** Abre el detalle de una notificación de la campana. */
      verEnvio(envio) {
         this.envioSel = envio
         this.dialogEnvio = true
      },
      /**
       * Si se llegó desde la campana de la barra superior, abre el detalle del
       * mes que se eligió allí. Después limpia la dirección, para que recargar
       * la página no lo vuelva a abrir y elegir el mismo mes otra vez funcione.
       */
      abrirEnvioDeLaRuta() {
         const anio = Number(this.$route.query.envioAnio)
         const mes = Number(this.$route.query.envioMes)
         if (!anio || !mes) return

         const abrir = () => {
            const envio = this.envios.find(
               (e) => e.anio === anio && e.mes === mes
            )
            if (envio) this.verEnvio(envio)

            const query = { ...this.$route.query }
            delete query.envioAnio
            delete query.envioMes
            this.$router.replace({ query }).catch(() => {})
         }

         // Se lee al momento: la campana pudo mostrar un estado más nuevo que
         // el de cuando se abrió la pantalla.
         this.cargarEnvios().then(abrir)
      },
      /**
       * Procesa el listado elegido en la campana. Es el mismo camino que el
       * botón del aviso; lo único que cambia es de qué mes se trata.
       */
      procesarEnvio() {
         this.dialogEnvio = false
         this.comenzarImportacion(this.envioSel)
      },
      /**
       * Lo primero es el ciclo: el listado de Registro Académico no lo trae con
       * el formato del módulo. Se propone el deducido y se deja cambiarlo.
       *
       * `envio` llega desde la campana; sin él se procesa el del aviso.
       */
      comenzarImportacion(envio) {
         // Se comprueba que sea un envío de verdad y no lo que Vue pase por
         // descuido: un @click sin paréntesis entrega el evento del ratón, y
         // leerle el mes deja el diálogo sin saber de qué mes se trata.
         const origen = envio && envio.anio && envio.mes ? envio : this.aviso

         this.objetivo = {
            anio: origen.anio,
            mes: origen.mes,
            mesNombre: origen.mesNombre
         }

         this.modoCiclo = 'automatico'
         this.ciclosDetectados = {}
         this.cicloManual = this.ciclo
         this.cicloAlternoManual = this.cicloAlterno

         axios
            .get('api/Integracion/padron-ra/ciclos', {
               params: { anio: this.objetivo.anio, mes: this.objetivo.mes }
            })
            .then(({ data }) => {
               this.ciclosDetectados = data || {}

               // Sin nada que proponer, se abre directamente en el modo manual
               // en vez de mostrar un aviso vacío.
               if (!this.ciclosDetectados.ciclo) this.modoCiclo = 'manual'
            })
            .catch(() => {
               this.modoCiclo = 'manual'
            })
            .finally(() => {
               this.dialogCiclo = true
            })
      },
      /** Ya hay ciclo: sigue el conflicto, si lo hay, o la importación. */
      continuarDesdeCiclo() {
         this.dialogCiclo = false

         if (this.aviso.requiereDecision) {
            this.decision = this.RA
            this.dialogConflicto = true
            return
         }

         this.importar(this.RA)
      },
      importar(decision) {
         if (!this.cicloElegido) {
            this.avisar('Indique primero el ciclo.', 'error')
            return
         }

         this.importando = true

         axios
            .post('api/Integracion/padron-ra/importar', {
               anio: this.objetivo.anio,
               mes: this.objetivo.mes,
               ciclo: this.cicloElegido,
               cicloAlterno: this.cicloAlternoElegido,
               decision,
               usuario: this.usuario
            })
            .then(({ data }) => {
               // El backend no toca nada mientras no se decida: si contesta esto
               // es porque apareció un conflicto que la pantalla no conocía.
               if (data.requiereDecision) {
                  this.decision = this.RA
                  this.mensajeConflicto = data.mensaje
                  this.dialogConflicto = true
                  return
               }

               this.dialogConflicto = false
               this.dialogCambios = false
               this.dialogEnvio = false
               this.avisar(data.mensaje)

               this.cargarAviso()
               this.$root.$emit(EVENTO_ENVIOS_ACTUALIZADOS)

               // Solo cuando algo cambió: si se conservó el Excel, el listado de
               // la pantalla sigue siendo el mismo.
               if (!data.descartado) {
                  this.$emit('padron-importado', {
                     anio: this.objetivo.anio,
                     mes: this.objetivo.mes,
                     ciclo: this.cicloElegido
                  })
               }
            })
            .catch((error) => {
               this.avisar(
                  this.mensajeError(error, 'No se pudo importar el listado.'),
                  'error'
               )
            })
            .finally(() => {
               this.importando = false
            })
      },

      verCambios(anio, mes) {
         axios
            .get('api/Integracion/padron-ra/cambios', { params: { anio, mes } })
            .then(({ data }) => {
               this.cambios = data || {}
               this.dialogCambios = true
            })
            .catch((error) => {
               this.avisar(
                  this.mensajeError(error, 'No se pudieron leer los cambios.'),
                  'error'
               )
            })
      },

      colorCambio(tipo) {
         if (tipo === 'AGREGADO') return 'green darken-2'
         if (tipo === 'QUITADO') return 'red darken-2'
         return 'orange darken-2'
      },
      colorEstado,
      etiquetaEstado
   }
}
</script>
